import { DOCUMENT } from '@angular/common';
import { ElementRef, inject, Injectable, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdobeDataLayerServiceSuperExtended } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  STANDALONE_PAGE_URL,
  VIEW_NAME
} from '../../data-access/login-modal/constants/login-constant';
import { AddAddressFacadeService } from '../../data-access/login-modal/facade/add-address/add-address-facade.service';
import { AddEmailAddressFacadeService } from '../../data-access/login-modal/facade/add-email-address/add-email-address-facade.service';
import { AddSqaFacadeService } from '../../data-access/login-modal/facade/add-sqa/add-sqa-facade.service';
import { CheckEmailFacadeService } from '../../data-access/login-modal/facade/check-email-facade/check-email-facade.service';
import { CreateMyPasswordFacade } from '../../data-access/login-modal/facade/create-my-password/create-my-password.facade';
import { CreatePasswordFacade } from '../../data-access/login-modal/facade/create-password/create-password.facade';
import { FacadeService } from '../../data-access/login-modal/facade/facade.service';
import { ForgotLoginFacadeService } from '../../data-access/login-modal/facade/forgot-login-facade/forgot-login-facade.service';
import { LoginHelpScreenFacadeService } from '../../data-access/login-modal/facade/login-help-screen-facade/login-help-screen-facade.service';
import { RecoverSQAFacadeService } from '../../data-access/login-modal/facade/recover-sqa-facade/recover-sqa-facade.service';
import { RecoverYourAccountFacadeService } from '../../data-access/login-modal/facade/recover-your-account-facade/recover-your-account-facade.service';
import { RecoveryOptionsFacade } from '../../data-access/login-modal/facade/recovery-options/recovery-options.facade';
import { ResetPasswordFacade } from '../../data-access/login-modal/facade/reset-password/reset-password.facade';
import { UnlockYourAccountFacadeService } from '../../data-access/login-modal/facade/unlock-your-account-facade/unlock-your-account-facade.service';
import { NextDisplayViewService } from '../../data-access/login-modal/services';
import { WifiPortalService } from '../../data-access/login-modal/services/wifi-portal/wifi-portal.service';
import { LoginHelperUtils } from '../../data-access/utils/login-helper.utils';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LoginModalHelperSuperSupportComponent {
  loadSpinner = false;
  totalHeight = 0;
  innerWidth = 0;
  showBackDrop = false;
  lastNameField = false;
  adobeDatalayerService = inject(AdobeDataLayerServiceSuperExtended);
  facade = inject(FacadeService);
  resetPasswordFacade = inject(ResetPasswordFacade);
  elementRef = inject(ElementRef);
  renderer = inject(Renderer2);
  unlockAccountFacadeService = inject(UnlockYourAccountFacadeService);
  loginHelpScreenFacadeService = inject(LoginHelpScreenFacadeService);
  forgotLoginFacade = inject(ForgotLoginFacadeService);
  nextDisplayViewService = inject(NextDisplayViewService);
  checkEmailFacadeService = inject(CheckEmailFacadeService);
  recoveryOptionsFacade = inject(RecoveryOptionsFacade);
  createPasswordFacade = inject(CreatePasswordFacade);
  createMyPasswordFacade = inject(CreateMyPasswordFacade);
  recoverSQAFacadeService = inject(RecoverSQAFacadeService);
  recoverYourAccountService = inject(RecoverYourAccountFacadeService);
  addEmailAddressFacadeService = inject(AddEmailAddressFacadeService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  addSqaFacade = inject(AddSqaFacadeService);
  addAddressFacade = inject(AddAddressFacadeService);
  wifiPortalService = inject(WifiPortalService);
  loginHelperUtils = inject(LoginHelperUtils);
  document = inject(DOCUMENT);
  successAdobeTracker$ = new BehaviorSubject(false);

  setStyleForStandaloneHelper(loginModalNative: ElementRef) {
    const navbar = document.querySelector('.navbar');
    const loginModalDiv = document.querySelector('.login-modal-container');
    this.renderer.setStyle(navbar, 'position', 'relative');
    this.renderer.setStyle(navbar, 'flex-wrap', 'nowrap');
    this.renderer.setStyle(loginModalNative, 'top', '0');
    this.renderer.setStyle(
      loginModalNative,
      'margin-top',
      `${this.totalHeight}px`
    );
    this.renderer.setStyle(loginModalDiv, 'max-height', 'none');
  }

  setLoaderForStandAlone() {
    document.addEventListener('DOMContentLoaded', () => {
      const loading = document.querySelector('.idp-loader__loading');
      const overlay = document.querySelector('.idp-loader__overlay');
      const loader = document.querySelector('.login-loader');
      const wrapper = document.querySelector('.login-modal-container');
      this.renderer.setStyle(overlay, 'right', '0');
      this.renderer.setStyle(overlay, 'width', '100vw');
      this.renderer.setStyle(overlay, 'margin', 'auto');
      this.renderer.setStyle(overlay, 'top', '0');
      this.renderer.setStyle(loading, 'margin', 'auto');
      this.renderer.setStyle(loading, 'z-index', '2001');
      this.renderer.setStyle(loading, 'left', '0');
      this.renderer.setStyle(loading, 'right', '0');
      this.renderer.setStyle(loading, 'position', 'fixed');
      this.renderer.setStyle(loader, 'position', 'absolute');
      this.renderer.setStyle(wrapper, 'overflow', 'hidden');
    });
  }

  focusTab(focusable: HTMLElement[], e: KeyboardEvent) {
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const shift = e.shiftKey;
    if (shift) {
      if (e.target === first) {
        last.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }

  displayNextScrenHelper(viewName: string): void {
    if (viewName === VIEW_NAME.RESET_PASSWORD_SCREEN) {
      this.resetPasswordFacade.resetPasswordContent$.next(null);
      this.resetPasswordFacade.getResetPasswordPageContent();
    }
  }

  displayNextScreen(viewName: string): void {
    if (!this.facade.standalonePage) {
      this.displayNextScrenHelper(viewName);
      this.nextDisplayViewService.nextDisplayView(viewName);
      this.loginHelperUtils.accountRecoveryAnalytics(viewName);
    } else {
      if (this.wifiPortalService.getQueryParamsWFP().isWFP) {
        this.wifiPortalService.getRefreshUrlWFP(true);
        return;
      }
      this.router.navigateByUrl(`/${STANDALONE_PAGE_URL[viewName]}`);
    }
  }
}
